import useLocalizedFormattedText from '@frolight/hooks/useLocalizedFormattedText';
import PropTypes from 'prop-types';
import { useState } from 'react';


const MasterDetail = ({ itemsTitle, items }) => {
  const{ lftext } = useLocalizedFormattedText();

  const [ selectedTabIndex, setSelectedTabIndex ] = useState(0);

  const handleTabClick = (e, newTabIndex) => {
    e.preventDefault();

    if (
      newTabIndex >= 0
      && newTabIndex < items.length
      && newTabIndex !== selectedTabIndex
    ) {
      setSelectedTabIndex(newTabIndex);
    }
  }

  return (
    <div className="master_detail">
      {
        items.length ? (
          <>
            <div className="master_detail__tabs">
              {
                itemsTitle ? (
                  <h2 className="master_detail__title">{ itemsTitle }</h2>
                ) : (
                  null
                )
              }
              <ul className="master_detail__tab_list">
                {
                  items.map((item, i) => {
                    return (
                      <li
                        key={ `master_detail_tab_list_item_${i}` }
                        className={ `master_detail__tab_list_item${i === selectedTabIndex ? "  master_detail__tab_list_item--selected" : ""}` }  
                      >
                        <button
                          type="button"
                          className="master_detail__tab_list_item_button"
                          role="tab"
                          id={ `master_detail_tab_${i}` }
                          aria-selected={ i === selectedTabIndex }
                          aria-controls={ `master_detail_tab_${i}_content` }
                          tabIndex={ i !== selectedTabIndex ? -1 : null }
                          onClick={ (e) => handleTabClick(e, i) }
                        >
                          {
                            item.icon && (
                              <span className="master_detail__tab_list_item_button_icon">
                                <i
                                  className={ `icon${ item.icon.status ? '  icon--' + item.icon.status : null }` }
                                  title={ item.icon.label }
                                >
                                  { item.icon.name }
                                </i>
                              </span>
                            )
                          }
                          <span className="master_detail__tab_list_item_button_label">
                            <span className="master_detail__tab_list_item_button_title">
                              {item.label}
                            </span>
                            {
                              item.metadata &&
                              <span className="master_detail__tab_list_item_button_metadata">
                                {item.metadata}
                              </span>
                            }
                          </span>
                        </button>
                      </li>
                    );
                  })
                }
              </ul>
            </div>
            <div className="master_detail__tab_content_items">
              {
                items.map((item, i) => (
                  <div
                    key={`master_detail_tab_${i}_content`}
                    className="master_detail__tab_content_item"
                    id={`master_detail_tab_${i}_content`}
                    role="tabpanel"
                    tabIndex="0"
                    aria-labelledby={`master_detail_tab_${i}`}
                  >
                    {i === selectedTabIndex ? item.content : null}
                  </div>
                ))
              }
            </div>
          </>
        ) : (
          <p>
            {lftext('pages.device_detail.no_data')}
          </p>
        )
      }
    </div>
  );
}

MasterDetail.propTypes = {
  itemsTitle: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        status: PropTypes.oneOf(['disabled', 'error', 'warning', 'success'])
      }),
      metadata: PropTypes.string,
      content: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
      ]).isRequired
    })
  )
};

export default MasterDetail;